export * from './layout-recorte-extracao-slice'